<div class="container-fluid">
  <nz-card>
    <div class="row mt-3">
      <div class="col-md-12">
        <app-data-grid
          id="gridContainer"
          [dataSource]="gridData"
          [searchPanel]="false"
          [filterRow]="false"
          [filterPanel]="false"
          [groupPanel]="false"
          [columnChooser]="false"
          [allowExport]="false"
          [pageSize]="10"
          [allowedPageSizes]="[10, 25, 50, 100]"
          [showPageSizeSelector]="true"
          [showBorders]="true"
        >
          <app-grid-column
            caption="S.No"
            cellTemplate="serialNumberTemplate"
            [width]="70"
          ></app-grid-column>

          <!--
          <app-grid-column dataField="sno" caption="Sno" [width]="100" alignment="center"></app-grid-column>
          -->

          <app-grid-column
            dataField="cty_nm"
            caption="City Name"
          ></app-grid-column>

          <app-grid-column
            dataField="i_ts"
            caption="Creation Time"
            alignment="center"
          ></app-grid-column>

          <app-grid-column
            dataField="u_ts"
            caption="Updated Time"
            alignment="center"
          ></app-grid-column>

          <app-grid-column
            dataField="crte_usr"
            caption="Created By"
            alignment="center"
          ></app-grid-column>

          <app-grid-column
            dataField="updte_usr"
            caption="Updated By"
            alignment="center"
          ></app-grid-column>

          <app-grid-column
            caption="Actions"
            [width]="100"
            cellTemplate="cellTemplate"
          ></app-grid-column>

          <ng-template appGridCell="cellTemplate" let-data="cell"
            ><div>
              <button
                nz-button
                nzType="primary"
                class="mr-2"
                (click)="editRecord(data.data)"
              >
                <i nz-icon nzType="edit"></i>
              </button>
              <button
                nz-button
                nzType="danger"
                (click)="deleteRecord(data.data)"
              >
                <i nz-icon nzType="delete"></i>
              </button></div
          ></ng-template>
          <ng-template appGridCell="serialNumberTemplate" let-data="cell"
            ><div>
              {{ data.rowIndex + 1 }}
            </div></ng-template
          >
        </app-data-grid>
      </div>
    </div>
  </nz-card>

  <nz-drawer
    [nzVisible]="shwSidebar"
    [nzTitle]="editdata ? 'Edit City' : 'Add City'"
    (nzOnClose)="closeSidebar()"
    [nzWidth]="500"
  >
    <ng-container *nzDrawerContent>
      @if (shwDeleteCnfrm == false) {
      <div>
        <form nz-form [formGroup]="cityForm" (ngSubmit)="submitForm()">
          <div class="row">
            <div class="col-md-12">
              <nz-form-item>
                <nz-form-label>City Name</nz-form-label>
                <nz-form-control>
                  <input
                    nz-input
                    formControlName="cty_nm"
                    placeholder="Enter city name"
                  />
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-12">
              <button
                nz-button
                nzType="primary"
                [nzLoading]="shwLdng"
                type="submit"
              >
                {{ editdata ? "Update" : "Save" }}
              </button>
              <button
                nz-button
                class="ml-2"
                type="button"
                (click)="closeSidebar()"
              >
                Cancel
              </button>
            </div>
          </div>
        </form>
      </div>
      } @if (shwDeleteCnfrm == true) {
      <div>
        <nz-alert
          nzType="warning"
          nzMessage="Warning"
          nzDescription="You are about to delete the following record."
          nzShowIcon
        ></nz-alert>
        <div>
          <div>
            <table class="del-confirm-table">
              <tr class="row">
                <td class="col">City</td>
                <td class="col">:{{ cityForm.value.cty_nm }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="row">
          <button
            nz-button
            nzType="default"
            class="col m-5"
            (click)="shwDeleteCnfrm = false"
          >
            Cancel
          </button>
          <button
            nz-button
            nzType="primary"
            class="col m-5"
            nz-popconfirm
            nzPopconfirmTitle="Are you sure to delete city?"
            nzPopconfirmPlacement="bottom"
            (nzOnConfirm)="confirmDelete()"
            (nzOnCancel)="shwDeleteCnfrm = false"
          >
            Delete
          </button>
        </div>
      </div>
      }
    </ng-container>
  </nz-drawer>
</div>
